/**
 * @generated SignedSource<<60a009d29cf65e9318f49c082024835e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompanySupport_company$data = {
  readonly preferences: {
    readonly support: {
      readonly email: string | null | undefined;
      readonly phone: string | null | undefined;
      readonly website: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanySupportEmail_company" | "PaymentCompanySupportPhone_company" | "PaymentCompanySupportWebsite_company" | "PaymentCompanySupportWhatsApp_company">;
  readonly " $fragmentType": "PaymentCompanySupport_company";
};
export type PaymentCompanySupport_company$key = {
  readonly " $data"?: PaymentCompanySupport_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanySupport_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompanySupport_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferencesSupport",
          "kind": "LinkedField",
          "name": "support",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "website",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompanySupportEmail_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompanySupportPhone_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompanySupportWebsite_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompanySupportWhatsApp_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "640ea059d9fe52ba368648be7b4cb590";

export default node;
